import { render, staticRenderFns } from "./flContent.vue?vue&type=template&id=246f489a"
import script from "./flContent.vue?vue&type=script&lang=js"
export * from "./flContent.vue?vue&type=script&lang=js"
import style0 from "./flContent.vue?vue&type=style&index=0&id=246f489a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports